import { AccessType } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';
export const accessTypeLabels = {
    [AccessType.Object]: COPY_SPECIFIC.OBJECT,
    [AccessType.PermissionSet]: COPY_SPECIFIC.PERMISSION_SET,
    [AccessType.Profile]: COPY_SPECIFIC.PROFILE,
    [AccessType.User]: COPY_SPECIFIC.USER
};
const accessTypeColors = {
    [AccessType.Object]: 'green',
    [AccessType.PermissionSet]: 'purple',
    [AccessType.Profile]: 'blue',
    [AccessType.User]: 'yellow'
};
export const AccessTypeTag = ({ accessType }) => React.createElement(Tag, { color: accessTypeColors[accessType] }, accessTypeLabels[accessType]);
